(function () {
  // Metafield intro video shown as a gallery slide that acts as a trigger:
  // - clicking the video thumbnail or the slide opens the pop-out player
  // - swiping/scrolling to the slide auto-opens the pop-out (if enabled)
  // Actual playback happens uncropped in the pop-out (window.openProductVideoModal).

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  function openFor(el) {
    var src = el.getAttribute('data-video-src');
    if (!src || typeof window.openProductVideoModal !== 'function') return;
    window.openProductVideoModal(src, el);
  }

  ready(function () {
    // Thumbnail tile -> open the pop-out, and autoplay its muted preview when visible
    document.querySelectorAll('[data-pvi-video-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();
        openFor(thumb);
      });

      var preview = thumb.querySelector('video');
      // poster mode renders an <img> here instead; only a media element is playable
      if (preview && typeof preview.play === 'function' && 'IntersectionObserver' in window) {
        var pio = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                if (preview.hasAttribute('data-lazy-src') && !preview.src) {
                  preview.src = preview.dataset.lazySrc;
                }
                preview.muted = true;
                preview.play().catch(function () {});
              } else {
                try { preview.pause(); } catch (_) {}
              }
            });
          },
          { threshold: 0.2 }
        );
        pio.observe(preview);
      }
    });

    // Video slide: click opens; swiping to it auto-opens (debounced, once per visit)
    document.querySelectorAll('[data-pvi-video-slide]').forEach(function (slide) {
      slide.addEventListener('click', function () { openFor(slide); });

      if (slide.getAttribute('data-pvi-autoopen') === 'false') return;

      var scroller = slide.closest('.product__media');
      if (!('IntersectionObserver' in window) || !scroller) return;

      var opened = false;
      var timer = null;
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting && entry.intersectionRatio >= 0.75) {
              if (opened) return;
              clearTimeout(timer);
              // small delay so quickly swiping past doesn't flash the pop-out
              timer = setTimeout(function () {
                opened = true;
                openFor(slide);
              }, 350);
            } else {
              clearTimeout(timer);
              opened = false; // reset so it can reopen next time it's swiped to
            }
          });
        },
        { root: scroller, threshold: [0, 0.75, 1] }
      );
      io.observe(slide);
    });
  });
})();
